多选下拉选择框

<template>
  <el-form-item
    :label="title"
    :id="field.FIELD_ID"
    :ref="field.FIELD_ID"
    :class="itemClass"
    v-if="isShow"
    :prop="field.FIELD_ID"
    :rules="rules">
    <el-select v-model="multiValue" :disabled="isDisabled" filterable multiple :placeholder="field.PLACE_HOLDER">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :filter-method="dataFilter"></el-option>
    </el-select>
    <!-- 选择框下方显示自定义提示语 -->
    <div v-if="field.SPECIAL_MSG" class="message-reminder warning-msg el-icon-warning" v-html="field.SPECIAL_MSG"></div>
  </el-form-item>
</template>

<script>
import oppService from "../../service/opp-service";
import stringPinyinConfig from "@/tools/stringPinyinConfig.js"; // 拼音处理插件

export default {
  data () {
    return {
      itemClass: "self-multiselector",
      options: [],
      all_options: [],
      isDisabled: false,
      triggerType: "custom",
      splitFlag: ",",
      rules: [],
    };
  },
  props: ["field", "index", "groupId", "isBaseUI", "selectChange"],
  created () {
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;

    if (this.isRequired)
      this.itemClass += " self-multiselector-required";

    if (this.isShowChange)
      this.itemClass += " self-multiselector-changed";
    if(this.field.splitFlag !== undefined){
      this.splitFlag = this.field.splitFlag;
    }
    this.getDataSource(this.dataSource);
    this.initDict();
  },
  computed: {
    //是否允许用户创建条目
    allowCreate: function () {
      return this.field.FIELD_ALLOW_CREATE ? true : false;
    },
    allowFilter: function () {
      return this.field.FIELD_ALLOW_FILTER ? true : false;
    },
    title: function () {
      this.field.FIELD_TITLE = this.field.FIELD_TITLE.replace("\\n", "\n");
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"]).length ? "" : "：") : "";
    },
    multiValue: {
      get: function () {
        if (typeof (this.field.DEFAULT_VALUE) == "string") {
          if (this.field.DEFAULT_VALUE == "") {
            return [];
          }
          let len = this.field.FIELD_DICT_NAME[0].DICT_ITEM.length;
          return this.field.DEFAULT_VALUE.split(this.splitFlag);
        }
        return this.field.DEFAULT_VALUE;
      },
      set: function (newValue) {
        this.field.DEFAULT_VALUE = newValue.join(this.splitFlag);
      }
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (this.isShowButton) {
        this.isDisabled = true;
      }
      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    dictFilterChange: function () {
      return this.field.FIELD_DICT_FILTER;
    },
    dictNameChange: function () {
      return this.field.FIELD_DICT_NAME;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    messageChange: function () {
      return this.field.message;
    },
    isShowChange: function () {
      return this.field.showchange;
    },
    isShowButton: function () {
      return this.field.IS_SHOW_BUTTON;
    },
    dataSource: function () {
      return this.field.DATA_SOURCE;
    }
  },
  methods: {
    initDict () {
      if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME !== "") {
        this.options = [];
        this.all_options = [];
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        _.forEach(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO
          //默认显示字典名称
          let newName = item.DICT_ITEM_NAME;
          // if (oppService.getSysCommonParamsFromCacheObjs("APP_SHOW_KEY_AND_VALUE") == "1") {
          //如果系统公参设置了显示key值跟value值，则显示字典值加上字典名称
          newName = item.DICT_ITEM + "-" + item.DICT_ITEM_NAME;
          // }
          let obj = { "value": item.DICT_ITEM, "label": newName, isDisabled: item.isDisabled};
          if (!showArr.length || showArr.length == this.field.FIELD_DICT_NAME.length) {
            //如果不用过滤,直接添加
            this.options.push(obj);
            this.all_options.push(obj);
          } else {
            //如果需要过滤，则满足条件添加
            if (showArr && showArr.indexOf(item.DICT_ITEM) !== -1) {
              this.options.push(obj);
              this.all_options.push(obj);
            }
          }
        });

      }
    },
    validatorField: function (rule, value, callback) {
      //隐藏的字段不校验
      // if(!this.isShow){
      //   return;
      // }
      value = this.field.DEFAULT_VALUE;
      if(this.field.inDictValid == "1"){
        //如果设置 属性值在字典了值为1.则必须校验值是否在下拉框中，如果不在则清除
        value = this.dealData(value);
      }
      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) { // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.correct = true;
        this.showErrorMsg = "";
        this.field.message = "";
        this.field.showerr = false;
        if (this.isBaseUI) {
          this.$emit("field-change", this.field);
        } else {
          this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
        }
        return callback();
      }
    },
    dataFilter (val) {
      let result = [];
      let options = this.all_options;
      // 中文匹配
      if (/[\u4e00-\u9fa5]+/.test(val)) {
        let arr = options.filter(item => {
          return item.label.includes(val);
        });
        result = result.concat(arr);

      } else {
        //非中文匹配
        let upperSearchBoxText = val.toUpperCase();
        let arr = options.filter(item => {
          let pinyin = stringPinyinConfig.ConvertPinyin(item.label).toUpperCase(),
            firstCapital = stringPinyinConfig.getAllFirstCapital(item.label).toUpperCase();

          return pinyin.includes(upperSearchBoxText) || firstCapital.includes(upperSearchBoxText);
        });
        result = result.concat(arr);
      }
      this.options = val === "" ? options : result;
    },
    dealData (val){
      if(!this.allowCreate && !!val){
        //当不允许手动创建条目时，值改变的时候判断是否在字典内
        let dict = this.field.FIELD_DICT_NAME || [];
        let filterDict = this.field.FIELD_DICT_FILTER || "";
        let dictVal = _.find(dict, {DICT_ITEM: val}) || {};
        if (_.isEmpty(dictVal) ||
            !_.isEmpty(filterDict) && (filterDict.indexOf("!") > -1 && filterDict.indexOf(val) > -1 ||
          filterDict.indexOf("!") == -1 && filterDict.indexOf(val) == -1)) {
          this.field.DEFAULT_VALUE = "";
          consoleLog("默认值不在下拉框里，数据清除");
          return "";
        }else{
          return val;
        }
      }
    },
    getDataSource (val) {
      this.itemClass = this.itemClass.replace("ocrIcon","");
      this.itemClass = this.itemClass.replace("zzIcon","");
      this.itemClass = this.itemClass.replace("zdIcon","");
      if (val == "1") {
        this.itemClass += " ocrIcon";
      } else if (val == "2") {
        this.itemClass += " zzIcon";
      } else if (val == "3") {
        this.itemClass += " zdIcon";
      }
    }
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-multiselector-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-multiselector-required/g, "");
      }
    },
    isShowChange: function (val) {
      if (val) {
        this.itemClass += " self-multiselector-changed";
      } else {
        this.itemClass = this.itemClass.replace(/self-multiselector-changed/g, "");
      }
    },
    dictFilterChange: function (val) {
      this.initDict();
    },
    dictNameChange: function (val) {
      this.initDict();
    },
    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID]&&this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // }
    },
    dataChange: {
      handler (newVal, oldVal) {
        //ocr识别回填字段时，会监听到，但是不需要去除ocr标识
        if(oldVal){
          //如果输入框中的值发生变化，ocr标识消失
          this.field.DATA_SOURCE = 0;
        }
        this.field.message = "";
        this.$refs[this.field.FIELD_ID]&&this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      },
      immediate: true
    },
    "field.DATA_SOURCE": {
      handler (val, oldVal) {
        this.getDataSource(val);
      },
      immediate: true
    }
  }
};
</script>

<style lang="less">
.self-multiselector {
  width: 100%;
  display: flex;
  min-height: 40px;
  .el-form-item__label {
    font-size: 14px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 14px;
    color: #000;
    flex: 1;
    // display: inline-flex;
    width: 100%;
    height: 100%;
    // 添加下拉框格式
    .el-select {
      width: 100%;
      .el-input__inner {
        // height:auto !important;
        padding-right: 50px;
        min-height: 40px;
      }
      .el-input__suffix {
        right: 20px;
      }
    }
  }
}

.self-multiselector-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

.self-multiselector-changed {
  input.el-input__inner {
    background: rgba(252, 230, 56, 0.2) !important;
  }
}

.warning-msg {
  color: #ff6c00;
  font-size: 14px;
  font-weight: bold;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/multiSelectorItem.vue